import '../card.scss';
import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LinkPage from '@components/atoms/LinkPage';
import useHover from '@assets/scripts/hooks/useHover';
//components
import ButtonPrimary from '@components/atoms/buttons/ButtonPrimary';
import Image from '@components/atoms/Image';

const CardHighlight = ({
	modifiers,
	className,
	link,
	image,
	uptitle,
	text,
	...otherProps
}) => {
	const baseClass = 'card-highlight';
	const defaultClass = 'card';

	const rootClass = cx(baseClass, className, defaultClass, {
		[`${baseClass}--${modifiers}`]: modifiers,
	});

	// interaction
	const [hoverOn, hoverOff] = useHover();

	const Link = link.url ? LinkPage : (props) => <span {...props}></span>;

	return (
		<div
			className={rootClass}
			data-card
			{...otherProps}
			data-animation-page
		>
			<p className="card__category uptitle">{uptitle}</p>
			<Link
				to={link.url}
				className="card__text-link"
				onMouseEnter={() => hoverOn()}
				onMouseLeave={() => hoverOff()}
				data-target
			>
				<p className="card__text">{text}</p>
			</Link>
			<Link
				to={link.url}
				className="card__thumbnail-link"
				onMouseEnter={() => hoverOn()}
				onMouseLeave={() => hoverOff()}
				data-target
			>
				<figure className="card__thumbnail" aria-label={uptitle}>
					<Image lassName="card__img" {...image} alt="" />
					<span className="card__shadow"></span>
				</figure>
			</Link>
			<div
				className="card__button"
				style={{ opacity: link.url ? 1 : 0.7 }}
			>
				<ButtonPrimary href={link.url} text={link.title} />
			</div>
		</div>
	);
};

CardHighlight.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	link: PropTypes.object.isRequired,
	image: PropTypes.object.isRequired,
	uptitle: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
};

export default CardHighlight;
